import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Separate axios instance for PUBLIC end-users. Attaches the public-user token
// (distinct from the admin `pd_token`) so admin and visitor sessions never mix.
const userApi = axios.create({ baseURL: API });

userApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pd_user_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default userApi;
